import React from 'react';
import { motion } from 'framer-motion';

const CHAPTERS = [
  {
    n: '01',
    title: 'Не турагентство. Автор.',
    body: 'Али сам ведёт каждую группу. Никаких субподрядчиков и рандомных сопровождающих — от аэропорта Дели до последнего ужина в Джайпуре с вами один человек, который знает Индию как своё второе имя.',
  },
  {
    n: '02',
    title: 'Индия, а не индийская выставка.',
    body: 'Никаких «туристических» ресторанов и постановочных танцевальных вечеров. Локальные семьи, домашние кухни, храмы на рассвете и рынки, куда возят своих — не туристов.',
  },
  {
    n: '03',
    title: 'Русский, без потери смысла.',
    body: 'Али бегло говорит по-русски и знает, как объяснить культурный код Индии человеку, выросшему в другом. Каждая экскурсия — это разговор, а не заученный текст.',
  },
  {
    n: '04',
    title: 'Небольшие группы. По-настоящему.',
    body: 'От 2 до 20 гостей. Мы работаем как «private guided experience» — размер группы не расширяется ради «наполненности».',
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-24 md:py-40 bg-espresso">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-12 gap-y-16">
          <div className="md:col-span-4 md:sticky md:top-32 self-start">
            <p className="overline mb-6">Manifesto · 4 principles</p>
            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-none text-foreground">
              Как мы<br />
              <em className="text-saffron">путешествуем</em>
            </h2>
          </div>

          <div className="md:col-span-8 space-y-14 md:space-y-20">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay: i * 0.06 }}
                className="grid grid-cols-12 gap-4 items-start border-t border-border/60 pt-8"
              >
                <div className="col-span-2 font-serif-display text-3xl md:text-5xl text-saffron italic">
                  {c.n}
                </div>
                <div className="col-span-10">
                  <h3 className="font-serif-display text-2xl md:text-4xl leading-tight mb-4 text-foreground">
                    {c.title}
                  </h3>
                  <p className="text-foreground/70 text-base md:text-lg leading-relaxed font-light max-w-xl">
                    {c.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
